import type { OrgChatArtifactPanelState } from '@/components/org-chat/org-chat-types';
import { isHiddenWorkspaceDotJsonPath } from '@/lib/workspace-panel-tabs';

const MAX_RESTORED_PANEL_TABS = 12;

/**
 * The panel tabs a persisted artifact-panel state restores on thread load, or
 * null when it restores closed. The single owner of those rules: thread
 * hydration applies the result, and the cold-load layout hint records only
 * whether it is non-null.
 */
export function resolveRestorableArtifactPanel(
  state: OrgChatArtifactPanelState | null | undefined
): { activePath: string; openPaths: string[] } | null {
  if (!state?.open) return null;
  const persistedActivePath = (state.activePath ?? state.path)?.trim();
  const persistedOpenPaths = (state.openPaths ?? [])
    .map((path) => path.trim())
    .filter(Boolean)
    .filter((path) => !isHiddenWorkspaceDotJsonPath(path))
    .slice(0, MAX_RESTORED_PANEL_TABS);
  const activePath =
    persistedActivePath && !isHiddenWorkspaceDotJsonPath(persistedActivePath)
      ? persistedActivePath
      : (persistedOpenPaths[0] ?? null);
  if (!activePath) return null;
  return {
    activePath,
    openPaths: persistedOpenPaths.includes(activePath)
      ? persistedOpenPaths
      : [activePath, ...persistedOpenPaths].slice(0, MAX_RESTORED_PANEL_TABS),
  };
}
